import api from '@/services/api';

export default {
  async saveAsset(asset: FormData) {
    return api.fetch('/assets', 'POST', asset);
  },
};
